import React from 'react';
import _ from 'lodash';

import { fetchDataReducer } from '@/reducers/fetch-data-reducer';
import { getVehicleAncapTestRecords } from '@/utils/apollo-requests/vehicles/get-vehicle-ancap-test-records';
import logger from '@/utils/logger';
import { type Dispatch, type RootState } from '@/app-state/store';

const useAncapRecord = (vehicleId: string, ssrAncapRecord?: object) => {
  // @ts-expect-error - I have no idea what is going on here.
  const [state, dispatch]: [RootState, Dispatch] = React.useReducer(fetchDataReducer, {
    isLoading: !ssrAncapRecord,
    hasError: false,
    data: ssrAncapRecord || {},
  });

  React.useEffect(() => {
    let isSubscribed = true;

    const shouldFetch = !ssrAncapRecord || _.isEmpty(state.data);

    if (!vehicleId) {
      logger.error('No Page Vehicle when fetching ANCAP Record', { ssrAncapRecord });
      dispatch({ type: 'FETCH_FAIL' });
    }

    if (vehicleId && shouldFetch) {
      dispatch({ type: 'FETCH_INIT' });
      getVehicleAncapTestRecords(vehicleId)
        .then((response) => {
          if (isSubscribed) {
            dispatch({
              type: 'FETCH_SUCCESS',
              payload: response,
            });
          }
        })
        .catch((err) => {
          logger.error('Error fetching ANCAP Record', err, { vehicleId, ssrAncapRecord });
          if (isSubscribed) {
            dispatch({ type: 'FETCH_FAIL' });
          }
        });
    }

    return () => {
      isSubscribed = false;
    };
  }, [vehicleId]);

  return state;
};

export default useAncapRecord;
